import Button from '../../Button'
import { useState } from 'react';
import WrapperComponent from './WrapperComponent'
import {UploadButton} from './TopBar.styles'

export default function UploadMedia() {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
      setIsModalOpen(true);
    }
  
    const closeModal = () => {
      setIsModalOpen(false);
    }
  

    return (
        <UploadButton>
            <Button theme="forestGreen" style={{ padding: '10px 20px' }} className="upload-new-media-button" onClick={openModal}>
                Upload new media
            </Button>
            <WrapperComponent isOpen={isModalOpen} onClickCancel={closeModal}/>
        </UploadButton>
    )
}
